const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";

export const env = {
  mobile: /Android|iPhone|iPad|iPod/i.test(ua) || (typeof navigator !== "undefined" && navigator.maxTouchPoints > 1 && /Macintosh/.test(ua)),
  firefox: /Firefox\//.test(ua),
  safari: /Safari\//.test(ua) && !/Chrome\/|Chromium\/|Edg\//.test(ua),
  mac: /Macintosh/.test(ua),
};

export const systemAudioSupport = () => {
  if (env.mobile) return "mobile";
  if (!navigator.mediaDevices?.getDisplayMedia) return "browser";
  if (env.firefox || env.safari) return "browser";
  return "ok";
};

export class NoSystemAudioError extends Error {
  constructor() { super("no-system-audio"); this.name = "NoSystemAudioError"; }
}

const getMic = () => navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true } });

const getSystem = async () => {
  const display = await navigator.mediaDevices.getDisplayMedia({
    video: true,
    audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false },
    systemAudio: "include", selfBrowserSurface: "exclude", surfaceSwitching: "include",
  });
  if (!display.getAudioTracks().length) {
    display.getTracks().forEach((t) => t.stop());
    throw new NoSystemAudioError();
  }
  return display;
};

// Returns an audio-only stream for recording, plus the tracks whose end means "capture stopped".
export async function openSource(mode) {
  if (mode === "mic") {
    const mic = await getMic();
    return { stream: mic, watch: mic.getAudioTracks(), stop: () => mic.getTracks().forEach((t) => t.stop()) };
  }
  const display = await getSystem();
  if (mode === "system") {
    const stream = new MediaStream(display.getAudioTracks());
    return { stream, watch: display.getTracks(), stop: () => display.getTracks().forEach((t) => t.stop()) };
  }
  let mic;
  try { mic = await getMic(); } catch (e) { display.getTracks().forEach((t) => t.stop()); e.fromMic = true; throw e; }
  const ctx = new AudioContext();
  const dest = ctx.createMediaStreamDestination();
  ctx.createMediaStreamSource(new MediaStream(display.getAudioTracks())).connect(dest);
  ctx.createMediaStreamSource(mic).connect(dest);
  return {
    stream: dest.stream,
    watch: [...display.getTracks(), ...mic.getAudioTracks()],
    stop: () => { display.getTracks().forEach((t) => t.stop()); mic.getTracks().forEach((t) => t.stop()); ctx.close().catch(() => {}); },
  };
}
